import { Injectable } from '@angular/core';
import { Backend } from '../_models/backend';
import JwtResponse = Backend.JwtResponse;
import LanguageType = Backend.LanguageType;

const USER_KEY = 'seos-auth-user';
const OAUTH_LOGIN_KEY = 'seos-oauth-login';
const VIRTUAL_CLASSROOM_KEY = 'seos-auth-virtual-classroom';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor() {
  }

  public saveUser(user: JwtResponse): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public saveBoard(user: JwtResponse): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): JwtResponse | null {
    const user = sessionStorage.getItem(USER_KEY);

    if (user != null) {
      return JSON.parse(user);
    }

    const virtualBoard = this.getVirtualBoard();

    if (virtualBoard != null) {
      this.saveUser(virtualBoard);

      this.clearLocalStorage();

      return virtualBoard;
    }

    const physicalBoard = localStorage.getItem(USER_KEY);

    if (physicalBoard != null) {
      return JSON.parse(physicalBoard);
    }

    return null;
  }

  public saveVirtualBoard(jwt: JwtResponse): void {
    window.localStorage.removeItem(VIRTUAL_CLASSROOM_KEY);
    window.localStorage.setItem(VIRTUAL_CLASSROOM_KEY, JSON.stringify(jwt));
  }

  public getVirtualBoard(): JwtResponse | null {
    const board = localStorage.getItem(VIRTUAL_CLASSROOM_KEY);

    if (board != null) {
      return JSON.parse(board);
    }
    return null;
  }

  public saveOauthLogin(oauthLogin: boolean | null | undefined): void {
    window.sessionStorage.removeItem(OAUTH_LOGIN_KEY);
    window.sessionStorage.setItem(OAUTH_LOGIN_KEY, JSON.stringify(oauthLogin));
  }

  public getOauthLogin(): boolean {
    const isOauthLogin = sessionStorage.getItem(OAUTH_LOGIN_KEY);

    if (isOauthLogin != null) {
      return JSON.parse(isOauthLogin);
    }
    return false;
  }

  public updateLanguage(language: LanguageType): void {
    const user = this.getUser();

    if (user != null) {
      user.languageType = language;
      window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    }
  }

  clearSessionStorage(): void {
    window.sessionStorage.clear();
  }

  clearLocalStorage(): void {
    window.localStorage.clear();
  }
}
